export default __webpack_public_path__ + "build/static/media/image-error-noInternet.153d7764.svg";